import { render } from "./BaseTable.vue?vue&type=template&id=8a4001e4&ts=true"
import script from "./BaseTable.vue?vue&type=script&lang=ts"
export * from "./BaseTable.vue?vue&type=script&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=8a4001e4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__